/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Grid, Skeleton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LoadingOverlay from '../../../../../Components/LoadingOverlay';

/**
 * PreviewFormSkeleton Component
 * @returns {JSX.Element}
 * @constructor
 */
export function PreviewFormSkeleton() {
  const { t } = useTranslation();

  return (
    <>
      <LoadingOverlay />
      <Typography mt={4} textAlign="center" variant="h2">
        5.
        {' '}
        {t('stepFiveHeader')}
      </Typography>
      <Typography sx={{ textAlign: 'center' }} variant="h4">
        {t('stepFiveSubHeadline')}
      </Typography>
      <Grid container mt={4} gap={2} sx={{ justifyContent: 'center' }}>
        <Grid item border="2px solid #49ad33" xs={12} md={8}>
          <Skeleton variant="rectangular" height={1200} />
        </Grid>
      </Grid>
    </>
  );
}
